export function extractBase64FromDataUrl(dataUrl) {
  if (typeof dataUrl !== 'string') return '';
  const parts = dataUrl.split(',');
  return parts[1] || '';
}

export function readImageFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event?.target?.result || '');
    reader.onerror = () => reject(new Error('Failed to read image file'));
    reader.readAsDataURL(file);
  });
}
